import { z } from 'zod'
import { NotificationChannelEnum } from '../../../domain/enums/NotificationChannel.enum'
import { CreateAndUpdateNotifiedUserDto } from '../../../domain/dtos/CreateAndUpdateNotifiedUser.dto'
import { E164PhoneSchema } from '../../../../@shared/infra/schemas/E164Phone.schema'

export const CreateNotifiedUserSchema = z
	.object({
		name: z.string(),
		email: z.email(),
		phoneNumber: E164PhoneSchema.nullable(),
		farms: z.array(z.string()).nonempty(),
		channels: z.array(z.enum(NotificationChannelEnum)).nonempty(),
		telegramChatId: z.number().int().optional(),
	})
	.transform((data) => {
		return {
			ids_areas_monitoradas_vinculadas: data.farms,
			nome: data.name,
			email: data.email,
			telefone: data.phoneNumber,
			identificador_chat_telegram: data.telegramChatId,
			canais_comunicacao: data.channels,
		} as CreateAndUpdateNotifiedUserDto
	})
